import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { ISupportReplyIm } from '../support-reply-im.model';
import { ISupportReplyVm } from '../support-reply-vm.model';

@Injectable({ providedIn: 'root' })
export class OperatorSupportReplyService {
  private readonly baseUrl: string;

  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/OperatorSupportReply`;
  }

  post(supportReplyIm: ISupportReplyIm): Observable<ISupportReplyVm> {
    const headers = this.createHeaders();
    return this.http.post<ISupportReplyVm>(this.baseUrl, supportReplyIm, { headers });
  }

  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
